export enum OngoingActionsEnum {
  IMPORTING = 'Importing',
  EXPORTING = 'Exporting',
  ARCHIVING = 'Archiving',
  BLACKLISTING = 'Blacklisting',
  UPDATE_DIFFERENCES_AND_PATCH_GBP = 'Updating differences and patching GBP',
  BULK_UPDATE_DIFFERENCES = 'Bulk-updating differences',
  UPDATE_IN_GBP = 'Updating in GBP',
  GET_UPDATES_FROM_GBP = 'Getting updates from GBP',
  BULK_ACCEPT_DIFFERENCES = 'Bulk-accept differences',
  UPDATE_GBP_GROUPS = 'Updating GBP groups',
  SYNC_REVIEWS = 'Syncing location reviews',
  CREATE_GBP_CONNECTION = 'Creating GBP connection',
  REMOVE_GBP_CONNECTION = 'Removing GBP connection',
}
